import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import type { AxiosError } from 'axios'

const isAxiosError = (error: Error): error is AxiosError => {
  return error.name === 'AxiosError' || error.constructor.name === 'AxiosError'
}
export const queryConfig: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry(failureCount, error) {
          if (isAxiosError(error) && error.response && error.response.status === 504) return true
          return false
        },
        retryDelay(failureCount) {
          const constantDelay = 3
          const backoff = 2
          const time = backoff ** (failureCount + 1) + constantDelay
          return time * 1000
        },
        refetchOnWindowFocus: false
      }
    }
  }
}
